import { ActionsUnion, createAction } from "../definitions";
import { ISuspiciousLogsSent, SuspiciousLogsSentActionTypes } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SuspiciousLogsSentActions = {
    setSuspiciousLogsSent: (payload: ISuspiciousLogsSent) => createAction(SuspiciousLogsSentActionTypes.SET_SUSPICIOUS_LOGS_SENT, payload),
    clearSuspiciousLogsSent: () => createAction(SuspiciousLogsSentActionTypes.CLEAR_SUSPICIOUS_LOGS_SENT)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SuspiciousLogsSentActions = ActionsUnion<typeof SuspiciousLogsSentActions>;
